import React, { useState, useEffect } from 'react';
import { Phone, Mail, MapPin, Clock, ExternalLink, X, Instagram } from 'lucide-react';
import { mockData } from '../mock';

const Footer = ({ scrollToSection }) => {
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);
  const [showAGB, setShowAGB] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  const handleNavClick = (section) => {
    if (scrollToSection) {
      scrollToSection(section);
    }
  };

  // Cookie Banner - nur einmal anzeigen
  useEffect(() => {
    const hasAcceptedCookies = localStorage.getItem('sv-rinno-cookies-accepted');
    if (!hasAcceptedCookies) {
      setShowCookieBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('sv-rinno-cookies-accepted', 'true');
    setShowCookieBanner(false);
  };
  return (
    <footer className="bg-[#004A6B] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4 -mt-3 -ml-1">
              <img 
                src="https://customer-assets.emergentagent.com/job_rinno-kfz/artifacts/xhxvn8uk_white-Photoroom%2817%29.png"
                alt="KFZ-Sachverständigenbüro Rinno Logo"
                className="h-20 sm:h-24 w-auto mb-1 block -ml-1"
              />
              <h3 className="text-xl font-bold text-[#93E2F1] m-0 p-0 -ml-1">
                KFZ-Sachverständigenbüro Rinno
              </h3>
            </div>
            <p className="text-gray-300 mb-4">
              Ihr vertrauensvoller Partner für professionelle KFZ-Gutachten und Schadensanalyse in ganz Deutschland.
            </p>
            <div className="flex items-center space-x-3 text-gray-300">
              <a 
                href="https://www.vfk-ev.de/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block px-3 py-1 bg-[#0078B5] hover:bg-[#02B4D8] rounded-full text-sm font-medium text-white transition-colors cursor-pointer"
              >
                Geprüft nach VFK e.V.
              </a>
            </div>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Kontakt</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin size={18} className="text-[#02B4D8] flex-shrink-0" />
                <div>
                  <p>Holzschuherstraße 42</p>
                  <p>90439 Nürnberg</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={18} className="text-[#02B4D8] flex-shrink-0" />
                <a href="tel:+4917662168132" className="hover:text-[#93E2F1] transition-colors">
                  +49 176 62168132
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-[#02B4D8] flex-shrink-0" />
                <a href="mailto:info@sv-rinno.de" className="hover:text-[#93E2F1] transition-colors">
                  info@sv-rinno.de
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Clock size={18} className="text-[#02B4D8] flex-shrink-0" />
                <p>9–18 Uhr</p>
              </div>
            </div>
          </div>
          
          {/* Navigation Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <div className="space-y-3">
              <button onClick={() => handleNavClick('process')} className="block hover:text-[#93E2F1] transition-colors cursor-pointer text-left">
                Unser Prozess
              </button>
              <button onClick={() => handleNavClick('services')} className="block hover:text-[#93E2F1] transition-colors cursor-pointer text-left">
                Service & Leistungen
              </button>
              <button onClick={() => handleNavClick('faq')} className="block hover:text-[#93E2F1] transition-colors cursor-pointer text-left">
                FAQ
              </button>
              <button onClick={() => handleNavClick('testimonials')} className="block hover:text-[#93E2F1] transition-colors cursor-pointer text-left">
                Bewertungen
              </button>
              <button onClick={() => handleNavClick('contact')} className="block hover:text-[#93E2F1] transition-colors cursor-pointer text-left">
                Kontakt
              </button>
            </div>
          </div>
          
          {/* Our Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Unsere Services</h4>
            <div className="space-y-3">
              <p className="block hover:text-[#93E2F1] transition-colors text-left">Unfall- & Schadengutachten</p>
              <p className="block hover:text-[#93E2F1] transition-colors text-left">Fahrzeugbewertungen & Wertgutachten</p>
              <p className="block hover:text-[#93E2F1] transition-colors text-left">Minderwertsgutachten (Restwertermittlung)</p>
              <p className="block hover:text-[#93E2F1] transition-colors text-left">Beweissicherung & Dokumentation</p>
              <p className="block hover:text-[#93E2F1] transition-colors text-left">Unterstützung bei der Schadensabwicklung</p>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Folgen Sie uns</h4>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/kfz.svb.rinno?igsh=eDNnOXp1cDdpdmti&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-3 bg-[#0078B5] hover:bg-[#02B4D8] rounded-full transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} className="text-white" />
              </a>
              <a 
                href="https://www.tiktok.com/@kfz.svb.rinno?_t=ZN-90CJFIFNgo7&_r=1" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-3 bg-[#0078B5] hover:bg-[#02B4D8] rounded-full transition-colors duration-300"
                aria-label="TikTok"
              >
                {/* TikTok Icon - Schärferes SVG */}
                <svg width="20" height="20" viewBox="0 0 448 512" fill="currentColor" className="text-white" style={{imageRendering: 'crisp-edges'}}>
                  <path d="M448 209.91a210.06 210.06 0 0 1-122.77-39.25V349.38A162.55 162.55 0 1 1 185 188.31V278.2a74.62 74.62 0 1 0 52.23 71.18V0h88a121.18 121.18 0 0 0 1.86 22.17h0A122.18 122.18 0 0 0 381 102.39a121.43 121.43 0 0 0 67 20.14Z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-gray-300">
            <p className="text-sm">&copy; 2025 KFZ-Sachverständigenbüro Rinno. Alle Rechte vorbehalten.</p>
            <div className="flex space-x-4 mt-3 md:mt-0">
              <button 
                onClick={() => setShowImpressum(true)}
                className="text-sm hover:text-white transition-colors cursor-pointer"
              >
                Impressum
              </button>
              <button 
                onClick={() => setShowDatenschutz(true)}
                className="text-sm hover:text-white transition-colors cursor-pointer"
              >
                Datenschutz
              </button>
              <button 
                onClick={() => setShowAGB(true)}
                className="text-sm hover:text-white transition-colors cursor-pointer"
              >
                AGB
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Impressum Modal */}
      {showImpressum && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900">Impressum</h2>
              <button
                onClick={() => setShowImpressum(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>
            
            {/* Content */}
            <div className="p-6">
              <div className="space-y-6 text-gray-700">
                {/* Angaben gemäß DDG */}
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG):</h3>
                  <div className="space-y-1">
                    <p className="font-medium text-gray-900">Omar Rinno</p>
                    <p>KFZ-Sachverständigenbüro Rinno</p>
                    <p>Holzschuherstraße 42</p>
                    <p>90439 Nürnberg</p>
                    <p>Deutschland</p>
                  </div>
                </div>
                
                {/* Kontaktdaten */}
                <div className="space-y-2">
                  <div className="flex items-center space-x-2">
                    <Phone size={16} className="text-[#0078B5]" />
                    <span className="text-sm text-gray-600">Telefon:</span>
                    <a href="tel:+4917662168132" className="text-[#0078B5] hover:underline">
                      +49 176 62168132
                    </a>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Mail size={16} className="text-[#0078B5]" />
                    <span className="text-sm text-gray-600">E-Mail:</span>
                    <a href="mailto:info@sv-rinno.de" className="text-[#0078B5] hover:underline">
                      info@sv-rinno.de
                    </a>
                  </div>
                  <div className="flex items-center space-x-2">
                    <ExternalLink size={16} className="text-[#0078B5]" />
                    <span className="text-sm text-gray-600">Website:</span>
                    <a href="https://www.kfz-sachverständigenbüro-rinno.de" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline">
                      https://www.kfz-sachverständigenbüro-rinno.de
                    </a>
                  </div>
                </div>
                
                {/* Umsatzsteuer */}
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:</h4>
                  <p>wird nachgereicht</p>
                </div>
                
                {/* Zuständige Kammer */}
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Zuständige Kammer:</h4>
                  <div className="space-y-1">
                    <p>Industrie- und Handelskammer Nürnberg für Mittelfranken</p>
                    <p>Ulmenstraße 52, 90443 Nürnberg</p>
                    <div className="flex items-center space-x-2">
                      <ExternalLink size={14} className="text-[#0078B5]" />
                      <span className="text-sm text-gray-600">Website:</span>
                      <a href="https://www.ihk-nuernberg.de" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline">
                        https://www.ihk-nuernberg.de
                      </a>
                    </div>
                  </div>
                </div>
                
                {/* Verantwortlich für den Inhalt */}
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Verantwortlich für den Inhalt nach § 18 Abs. 2 Medienstaatsvertrag (MStV):</h4>
                  <div className="space-y-1">
                    <p className="font-medium">Omar Rinno</p>
                    <p>Holzschuherstraße 42</p>
                    <p>90439 Nürnberg</p>
                  </div>
                </div>
                
                {/* Berufsbezeichnung */}
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Berufsbezeichnung:</h4>
                  <p>KFZ-Sachverständiger (Deutschland)</p>
                  <p className="text-sm text-gray-600 mt-1">Qualifikation erworben durch Schulung beim Verband freier Kraftfahrzeug-Sachverständiger e.V. (VfK)</p>
                </div>
                
                {/* Streitbeilegung */}
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Streitbeilegung nach § 36 Verbraucherstreitbeilegungsgesetz (VSBG):</h4>
                  <p>Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Datenschutz Modal */}
      {showDatenschutz && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white rounded-t-xl z-10">
              <h2 className="text-2xl font-bold text-gray-900">🧾 Datenschutzerklärung</h2>
              <button
                onClick={() => setShowDatenschutz(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>
            
            {/* Content */}
            <div className="p-6">
              <div className="space-y-6 text-gray-700">
                {/* Stand */}
                <p className="text-sm text-gray-500 mb-6">Stand: 06.10.2025</p>
                
                {/* 1. Allgemeine Hinweise */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">1. Allgemeine Hinweise</h3>
                  <div className="space-y-2">
                    <p>Soweit nachstehend keine anderen Angaben gemacht werden, ist die Bereitstellung Ihrer personenbezogenen Daten weder gesetzlich noch vertraglich vorgeschrieben.</p>
                    <p>Sie sind zur Bereitstellung der Daten nicht verpflichtet. Eine Nichtbereitstellung hat keine Folgen.</p>
                    <p>Dies gilt nur, soweit bei den nachfolgenden Verarbeitungsvorgängen keine anderweitige Angabe gemacht wird.</p>
                    <p>„Personenbezogene Daten" sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen.</p>
                  </div>
                </div>
                
                {/* 2. Verantwortlicher */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">2. Verantwortlicher</h3>
                  <p className="mb-2">Verantwortlicher für die Datenverarbeitung im Rahmen dieser Website und der angebotenen Gutachterdienstleistungen ist:</p>
                  <div className="space-y-1 bg-gray-50 p-4 rounded-lg">
                    <p className="font-medium text-gray-900">Omar Rinno</p>
                    <p>Holzschuherstraße 42</p>
                    <p>90439 Nürnberg</p>
                    <p>Deutschland</p>
                    <div className="pt-2 space-y-1">
                      <p><strong>Telefon:</strong> <a href="tel:+4917662168132" className="text-[#0078B5] hover:underline">+49 176 62168132</a></p>
                      <p><strong>E-Mail:</strong> <a href="mailto:info@sv-rinno.de" className="text-[#0078B5] hover:underline">info@sv-rinno.de</a></p>
                    </div>
                  </div>
                </div>
                
                {/* 3. Server-Logfiles */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">3. Server-Logfiles</h3>
                  <div className="space-y-2">
                    <p>Beim Besuch unserer Website werden durch Ihren Browser automatisch Nutzungsdaten an uns bzw. unseren Webhoster übermittelt und in sogenannten Server-Logfiles gespeichert.</p>
                    <p>Erfasst werden unter anderem: Name der abgerufenen Seite, Datum und Uhrzeit des Abrufs, IP-Adresse, übertragene Datenmenge und der anfragende Provider.</p>
                    <p>Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO aufgrund unseres berechtigten Interesses an der Gewährleistung eines störungsfreien Betriebs der Website sowie zur Verbesserung unseres Angebotes.</p>
                  </div>
                </div>
                
                {/* 4. Kontaktaufnahme */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">4. Kontaktaufnahme per E-Mail oder Kontaktformular</h3>
                  <div className="space-y-2">
                    <p>Wenn Sie uns per E-Mail oder über das Kontaktformular kontaktieren, verarbeiten wir die von Ihnen angegebenen Daten (Name, E-Mail-Adresse, Nachrichtentext) ausschließlich zum Zweck der Bearbeitung und Beantwortung Ihrer Anfrage.</p>
                    <p>Wenn Ihre Anfrage auf eine Gutachtenerstellung oder eine Angebotserstellung gerichtet ist, erfolgt die Verarbeitung gemäß Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen).</p>
                    <p>In allen anderen Fällen erfolgt die Verarbeitung gemäß Art. 6 Abs. 1 lit. f DSGVO aufgrund unseres berechtigten Interesses an der Beantwortung von Anfragen.</p>
                    <p>Ihre Daten werden gelöscht, sobald sie für die Erreichung des Zweckes nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungsfristen entgegenstehen.</p>
                  </div>
                </div>
                
                {/* 5. Online-Terminbuchung */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">5. Online-Terminbuchung</h3>
                  <div className="space-y-2">
                    <p>Wenn Sie über unseren Online-Terminplaner einen Termin anfragen, verarbeiten wir die von Ihnen angegebenen Daten (z. B. Name, E-Mail-Adresse, gewünschter Termin) ausschließlich zur Terminvereinbarung und eventueller Rückfragen.</p>
                    <p>Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.</p>
                  </div>
                </div>
                
                {/* 6. WhatsApp Business */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">6. WhatsApp Business (optional)</h3>
                  <div className="space-y-2">
                    <p>Wenn Sie über WhatsApp mit uns Kontakt aufnehmen, nutzen wir die Business-Version von WhatsApp (WhatsApp Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland).</p>
                    <p>Wir verarbeiten dabei Ihre Telefonnummer, Ihren Namen (falls angegeben) sowie den Inhalt Ihrer Nachricht.</p>
                    <p>Die Daten werden ausschließlich zur Beantwortung Ihrer Anfrage verwendet.</p>
                    <p>Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, sofern sich Ihre Anfrage auf ein Gutachten bezieht, andernfalls Art. 6 Abs. 1 lit. f DSGVO.</p>
                    <p><strong>Informationen zum Datenschutz bei WhatsApp:</strong><br />
                       <a href="https://www.whatsapp.com/legal/#privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline">https://www.whatsapp.com/legal/#privacy-policy</a>
                    </p>
                  </div>
                </div>
                
                {/* 7. Cookies */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">7. Cookies</h3>
                  <div className="space-y-2">
                    <p>Unsere Website verwendet ausschließlich technisch notwendige Cookies, die für die Funktionalität (z. B. Formular- oder Terminbuchungssystem) erforderlich sind.</p>
                    <p>Die Nutzung erfolgt auf Grundlage des § 25 Abs. 2 TDDDG sowie Art. 6 Abs. 1 lit. f DSGVO, da wir ein berechtigtes Interesse an einem sicheren und nutzerfreundlichen Betrieb der Website haben.</p>
                    <p>Sie können Cookies jederzeit über die Einstellungen Ihres Browsers löschen oder blockieren.</p>
                    <p><strong>Informationen hierzu finden Sie bei:</strong><br />
                       <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline">Chrome</a> | 
                       <a href="https://support.microsoft.com/de-de/help/17442" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline"> Edge</a> | 
                       <a href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline"> Firefox</a> | 
                       <a href="https://support.apple.com/de-de/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline"> Safari</a>
                    </p>
                  </div>
                </div>
                
                {/* 8. Google Maps */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">8. Google Maps</h3>
                  <div className="space-y-2">
                    <p>Sofern auf unserer Website eine Karte eingebunden ist, nutzen wir den Kartendienst Google Maps der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.</p>
                    <p>Die Nutzung erfolgt zur Darstellung unseres Standortes und zur erleichterten Anfahrt.</p>
                    <p>Hierbei können personenbezogene Daten (z. B. IP-Adresse, Standortdaten) an Server von Google übermittelt werden.</p>
                    <p>Rechtsgrundlage ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.</p>
                    <p>Sie können Ihre Einwilligung jederzeit widerrufen.</p>
                    <p><strong>Weitere Informationen zum Datenschutz bei Google:</strong><br />
                       <a href="https://www.google.com/privacypolicy.html" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline">https://www.google.com/privacypolicy.html</a>
                    </p>
                  </div>
                </div>
                
                {/* 9. Social Media */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">9. Verlinkung auf Social-Media-Profile</h3>
                  <div className="space-y-2">
                    <p>Auf unserer Website finden Sie Links zu unseren Profilen auf den Plattformen Instagram und TikTok.</p>
                    <p>Diese Links sind als einfache Schaltflächen eingebunden. Beim Aufruf unserer Website werden keine Daten an die Betreiber dieser Plattformen übermittelt.</p>
                    <p>Erst wenn Sie auf den jeweiligen Link klicken, öffnet sich die Plattform in einem neuen Fenster, und es gelten deren Datenschutzrichtlinien:</p>
                    <ul className="list-disc ml-6 space-y-1">
                      <li><a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline">Instagram (Meta Platforms Ireland Ltd.)</a></li>
                      <li><a href="https://www.tiktok.com/legal/page/row/privacy-policy/en" target="_blank" rel="noopener noreferrer" className="text-[#0078B5] hover:underline">TikTok (TikTok Technology Limited, Irland)</a></li>
                    </ul>
                  </div>
                </div>
                
                {/* 10. Rechte */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">10. Rechte der betroffenen Person</h3>
                  <div className="space-y-2">
                    <p>Sie haben das Recht, jederzeit Auskunft über die bei uns gespeicherten personenbezogenen Daten zu verlangen (Art. 15 DSGVO).</p>
                    <p>Zudem haben Sie das Recht auf Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO) und Datenübertragbarkeit (Art. 20 DSGVO).</p>
                    <p>Darüber hinaus steht Ihnen ein Widerspruchsrecht nach Art. 21 DSGVO zu.</p>
                  </div>
                </div>
                
                {/* 11. Beschwerderecht */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">11. Beschwerderecht bei der Aufsichtsbehörde</h3>
                  <div className="space-y-2">
                    <p>Sie haben gemäß Art. 77 DSGVO das Recht, sich bei einer Aufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten nicht rechtmäßig erfolgt.</p>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p><strong>Zuständige Aufsichtsbehörde:</strong></p>
                      <p>Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)</p>
                      <p>Promenade 18, 91522 Ansbach</p>
                      <p><strong>Tel.:</strong> <a href="tel:+4998118009300" className="text-[#0078B5] hover:underline">+49 981 1800930</a></p>
                      <p><strong>E-Mail:</strong> <a href="mailto:poststelle@lda.bayern.de" className="text-[#0078B5] hover:underline">poststelle@lda.bayern.de</a></p>
                    </div>
                  </div>
                </div>
                
                {/* 12. Widerspruchsrecht */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">12. Widerspruchsrecht</h3>
                  <div className="space-y-2">
                    <p>Wenn Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit Widerspruch gegen die Verarbeitung einzulegen.</p>
                    <p>Nach einem Widerspruch werden wir die Verarbeitung Ihrer Daten beenden, es sei denn, es bestehen zwingende schutzwürdige Gründe oder gesetzliche Aufbewahrungspflichten.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* AGB Modal */}
      {showAGB && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white rounded-t-xl z-10">
              <h2 className="text-2xl font-bold text-gray-900">🧾 Allgemeine Geschäftsbedingungen (AGB)</h2>
              <button
                onClick={() => setShowAGB(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X size={20} className="text-gray-500" />
              </button>
            </div>
            
            {/* Content */}
            <div className="p-6">
              <div className="space-y-6 text-gray-700">
                {/* Stand */}
                <p className="text-sm text-gray-500 mb-6">Stand: 06.10.2025</p>
                
                {/* 1. Geltungsbereich */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">1. Geltungsbereich</h3>
                  <div className="space-y-2">
                    <p>Diese Allgemeinen Geschäftsbedingungen gelten für alle Aufträge, Gutachten, Bewertungen und Beratungsleistungen, die von</p>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="font-medium">Omar Rinno, Sachverständigenbüro Rinno</p>
                      <p>Holzschuherstraße 42, 90439 Nürnberg</p>
                      <p className="text-sm text-gray-600">(im Folgenden „Sachverständiger" genannt)</p>
                    </div>
                    <p>für Auftraggeber (im Folgenden „Kunde") erbracht werden.</p>
                    <p>Abweichende Bedingungen des Kunden gelten nur, wenn sie ausdrücklich schriftlich anerkannt wurden.</p>
                  </div>
                </div>
                
                {/* 2. Vertragsabschluss */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">2. Vertragsabschluss</h3>
                  <div className="space-y-2">
                    <p>Ein Vertrag zwischen dem Sachverständigen und dem Kunden kommt zustande durch</p>
                    <ul className="list-disc ml-6 space-y-1">
                      <li>schriftliche Bestätigung eines Auftrags (z. B. per E-Mail),</li>
                      <li>mündliche Beauftragung (z. B. telefonisch oder persönlich) oder</li>
                      <li>Terminvereinbarung über das Online-Kalender- oder Kontaktformularsystem.</li>
                    </ul>
                    <p>Der Sachverständige behält sich vor, Aufträge ohne Angabe von Gründen abzulehnen, insbesondere wenn ein Interessenkonflikt besteht oder die Neutralität gefährdet wäre.</p>
                  </div>
                </div>
                
                {/* 3. Leistungsumfang */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">3. Leistungsumfang</h3>
                  <div className="space-y-2">
                    <p>Der genaue Leistungsumfang (z. B. Art des Gutachtens, Ort der Besichtigung, Umfang der Dokumentation) wird individuell vereinbart.</p>
                    <p>Das Gutachten wird nach bestem Wissen, Gewissen und unter Beachtung der anerkannten Regeln der Technik und Sachkunde erstellt.</p>
                    <p>Das Ergebnis eines Gutachtens stellt keine Garantie für das Vorliegen bestimmter Eigenschaften oder zukünftiger Entwicklungen dar.</p>
                  </div>
                </div>
                
                {/* 4. Pflichten des Kunden */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">4. Pflichten des Kunden</h3>
                  <div className="space-y-2">
                    <p>Der Kunde verpflichtet sich, alle für die Erstellung des Gutachtens notwendigen Unterlagen, Auskünfte und Zugangsmöglichkeiten rechtzeitig bereitzustellen.</p>
                    <p>Verzögerungen, die auf fehlende Mitwirkung zurückzuführen sind, gehen nicht zu Lasten des Sachverständigen.</p>
                  </div>
                </div>
                
                {/* 5. Vergütung */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">5. Vergütung</h3>
                  <div className="space-y-2">
                    <p>Die Vergütung erfolgt nach Vereinbarung, wahlweise auf Stundenbasis, als Pauschalhonorar oder nach der jeweils gültigen Honorartabelle des Sachverständigen.</p>
                    <p>Alle Preise verstehen sich in Euro und enthalten, sofern nicht anders ausgewiesen, die gesetzliche Mehrwertsteuer.</p>
                    <p>Die Rechnung ist sofort nach Erhalt ohne Abzug fällig.</p>
                    <p>Der Sachverständige ist berechtigt, bei Auftragserteilung eine angemessene Vorauszahlung zu verlangen.</p>
                  </div>
                </div>
                
                {/* 6. Stornierung */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">6. Stornierung / Terminabsage</h3>
                  <div className="space-y-2">
                    <p>Wird ein bereits vereinbarter Termin durch den Kunden weniger als 24 Stunden vorher abgesagt oder nicht wahrgenommen, kann eine Ausfallpauschale bis zu 50 % des vereinbarten Honorars berechnet werden, sofern kein Ersatztermin zustande kommt.</p>
                  </div>
                </div>
                
                {/* 7. Haftung */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">7. Haftung</h3>
                  <div className="space-y-2">
                    <p>Der Sachverständige haftet nur für Schäden, die auf vorsätzliche oder grob fahrlässige Pflichtverletzungen zurückzuführen sind.</p>
                    <p>Bei einfacher Fahrlässigkeit haftet er nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) und nur bis zur Höhe des vertragstypisch vorhersehbaren Schadens.</p>
                    <p>Ansprüche wegen Folgeschäden, entgangenem Gewinn oder mittelbaren Schäden sind ausgeschlossen, sofern nicht gesetzlich zwingend etwas anderes bestimmt ist.</p>
                  </div>
                </div>
                
                {/* 8. Urheberrecht */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">8. Urheberrecht / Nutzungsrechte</h3>
                  <div className="space-y-2">
                    <p>Das vom Sachverständigen erstellte Gutachten, inklusive Texten, Bildern und Berechnungen, ist urheberrechtlich geschützt.</p>
                    <p>Es darf nur für den im Auftrag vereinbarten Zweck verwendet werden.</p>
                    <p>Jede Vervielfältigung, Veröffentlichung oder Weitergabe an Dritte bedarf der schriftlichen Zustimmung des Sachverständigen.</p>
                  </div>
                </div>
                
                {/* 9. Datenschutz */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">9. Datenschutz</h3>
                  <div className="space-y-2">
                    <p>Personenbezogene Daten des Kunden werden nur im Rahmen der gesetzlichen Bestimmungen (DSGVO, BDSG) verarbeitet.</p>
                    <p>Details hierzu sind der <button onClick={() => {setShowAGB(false); setShowDatenschutz(true);}} className="text-[#0078B5] hover:underline cursor-pointer">Datenschutzerklärung</button> auf unserer Website zu entnehmen.</p>
                  </div>
                </div>
                
                {/* 10. Vertraulichkeit */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">10. Vertraulichkeit</h3>
                  <div className="space-y-2">
                    <p>Der Sachverständige verpflichtet sich, alle ihm im Rahmen seiner Tätigkeit bekannt gewordenen Informationen vertraulich zu behandeln und Dritten nur insoweit zugänglich zu machen, wie es zur Durchführung des Auftrages erforderlich ist.</p>
                  </div>
                </div>
                
                {/* 11. Speicherung */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">11. Speicherung von Daten und Aufbewahrung</h3>
                  <div className="space-y-2">
                    <p>Gutachten und zugehörige Unterlagen können zum Nachweis der erbrachten Leistung für einen angemessenen Zeitraum archiviert werden (in der Regel 10 Jahre).</p>
                    <p>Eine darüber hinausgehende Aufbewahrung erfolgt nur, wenn gesetzliche Vorschriften dies erfordern.</p>
                  </div>
                </div>
                
                {/* 12. Schlussbestimmungen */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-3">12. Schlussbestimmungen</h3>
                  <div className="space-y-2">
                    <p>Es gilt das Recht der Bundesrepublik Deutschland.</p>
                    <p>Gerichtsstand ist, soweit gesetzlich zulässig, Nürnberg.</p>
                    <p>Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Gültigkeit der übrigen Regelungen unberührt.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Cookie Consent Banner - nur beim ersten Besuch */}
      {showCookieBanner && (
        <div className="fixed bottom-0 left-0 right-0 bg-[#004A6B] text-white p-4 shadow-lg z-50">
          <div className="container mx-auto flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
            <p className="text-sm">
              Diese Website verwendet Cookies für eine optimale Nutzererfahrung und zur Einbindung von Google Maps sowie Microsoft Bookings.
            </p>
            <div className="flex space-x-3">
              <button 
                className="bg-[#0078B5] hover:bg-[#02B4D8] px-4 py-2 rounded text-sm font-medium transition-colors"
                onClick={acceptCookies}
              >
                Akzeptieren
              </button>
              <button 
                onClick={() => setShowDatenschutz(true)}
                className="text-[#93E2F1] hover:underline text-sm cursor-pointer"
              >
                Mehr erfahren
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;